module.exports = __webpack_public_path__ + "img/hero-image.f655e3fa.svg";